import { render, staticRenderFns } from "./BoxeWinLog.vue?vue&type=template&id=41f5d620&scoped=true&"
import script from "./BoxeWinLog.vue?vue&type=script&lang=js&"
export * from "./BoxeWinLog.vue?vue&type=script&lang=js&"
import style0 from "./BoxeWinLog.vue?vue&type=style&index=0&id=41f5d620&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f5d620",
  null
  
)

export default component.exports